import React from "react";
import "../Responsewidget.css";

const Responsewidget = () => {



  return (

    <div  className="main-div-respones-widget" >
        <p className="case-study">   <img src="/assets/images/lern-topic.svg" alt="correct" /> Learn This Topic</p>
      <div className="card-container">
      <div className="header-response-widget" style={{display:'flex',justifyContent:"space-between"}}>
        <div>
        <p className="category">Indian Economy</p>
        <h2 className="title">Govt. Administrations</h2>
        </div>
         <div>
         <button className="lbuton">
          <span className="text-button">Start Learning</span> 
        </button>
         </div>
      </div>
      <div className="main-div-pry-response">
        <div className="image-section">
          <img
            src="https://truedata.in/content/uploads/blogimages/key-highlights-of-budget-2024.jpg"
            alt="chart"
            className="thumb"
          />
          <img
            src="https://truedata.in/content/uploads/blogimages/key-highlights-of-budget-2024.jpg"
            alt="budget"
            className="thumb"
          />
          <img
            src="https://truedata.in/content/uploads/blogimages/key-highlights-of-budget-2024.jpg"
            alt="data"
            className="thumb"
          />
          <div className="more-box">+2</div>
        </div>

        <div className="cards-button">
          <button
            className="button-responsewidgets"
            
            
          >
           Previous Year Questions
           <img
                src="/assets/images/keyword-arrow.svg"
                className="img-arrow"
                alt="star"
              />
          </button>
          <button
            className="button-responsewidgets"
            
           
          >
            {" "}
            Case Studies
            <img
                src="/assets/images/keyword-arrow.svg"
                className="img-arrow"
                alt="star"
              />
          </button>
          <button
            className="button-responsewidgets"
          
         
          >
            Infographics/Mindmaps
            <img
                src="/assets/images/keyword-arrow.svg"
                className="img-arrow"
                alt="star"
              />
          </button>
        </div>
      </div>

      <p className="description">
        The Budget 2025 has emerged as a transformative blueprint aimed at
        driving economic growth, fostering inclusivity, and embracing
        sustainability. Presented amidst evolving global challenges and domestic
        priorities, this budget focuses on empowering key sectors such as
        infrastructure, healthcare, education, and green energy.
      </p>


    </div>
    </div>
    
  );
};

export default Responsewidget;